/** GoogleAnalyticsEventCategory */
enum GoogleAnalyticsEventCategory {
  FakturomaniaWebsite = "FakturomaniaWebsite"
}

/** GoogleAnalyticsEventType */
enum GoogleAnalyticsEventType {
  /** UNIVERSALNE => DO FUNNELA PO PAGEVIEW FILTROWAC MOZNA BEDZIE */
  NavigatedToAppLoginPage = "NavigatedToAppLoginPage",
  NavigatedToAppRegisterPage = "NavigatedToAppRegisterPage",
  ClickedCTAButtonAtPromoBlock = "ClickedCTAButtonAtPromoBlock",
  ClickedAtTestimonialBlock = "ClickedAtTestimonialBlock",
  PageFooterViewed = "PageFooterViewed",
  PageFooterNavigateToSocialClicked = "PageFooterNavigateToSocialClicked",

  /** LANDING PAGE */
  LandingPageViewedMainTitleBlock = "LandingPageViewedMainTitleBlock",
  LandingPageClickedCTAButtonAtMainTitleBlock = "LandingPageClickedCTAButtonAtMainTitleBlock",
  LandingPageViewedIntroStepBlock = "LandingPageViewedIntroStepBlock",
  LandingPageViewedOdometersBlock = "LandingPageViewedOdometersBlock",
  LandingPageViewedFeaturesBlock = "LandingPageViewedFeaturesBlock",
  LandingPageNavigatedToPackagesComparisonPage = "LandingPageNavigatedToPackagesComparisonPage",
  LandingPageViewedDescriptionBlock = "LandingPageViewedDescriptionBlock",
  LandingPageClickedCTAButtonAtDescriptionBlock = "LandingPageClickedCTAButtonAtDescriptionBlock",
  LandingPageViewedAchievementsBlock = "LandingPageViewedAchievementsBlock",

  /** FUNKCJE */
  FunkcjePageViewedFeaturesBlock = "FunkcjePageViewedFeaturesBlock",
  FunkcjePageNavigatedToPackagesComparisonPage = "FunkcjePageNavigatedToPackagesComparisonPage",
  FunkcjePageViewedDetailsBlock = "FunkcjePageViewedDetailsBlock",
  FunkcjePageClickedCTAButtonAtDetailsBlock = "FunkcjePageClickedCTAButtonAtDetailsBlock",

  /** CENNIK */
  CennikPageViewedMainPricingBlock = "CennikPageViewedMainPricingBlock",
  CennikPageClickedCTAAtMainPricingBlock = "CennikPageClickedCTAAtMainPricingBlock",
  CennikPageNavigatedToPackagesComparisonPage = "CennikPageNavigatedToPackagesComparisonPage",
  CennikPageViewedFeaturesBlock = "CennikPageViewedFeaturesBlock",
  CennikPageViewedFaqBlock = "CennikPageViewedFaqBlock",
  CennikPageReadFaqQuestion = "CennikPageReadFaqQuestion",

  /** NASZ ZESPÓŁ => NA RAZIE NIC NIE SLEDZIMY POAZA PAGEVIEW */

  /** PLANY ROZWOJU */
  NavigatedToPlanyRozwoju = "NavigatedToPlanyRozwoju",

  /** REGULAMIN SERWISU => NA RAZIE NIC NIE SLEDZIMY POAZA PAGEVIEW */
  /** REGULAMIN COOKIES => NA RAZIE NIC NIE SLEDZIMY POAZA PAGEVIEW */

  /** BIURO RACHUNKOWE */
  BiuroRachunkowePageViewedMainTitleBlock = "BiuroRachunkowePageViewedMainTitleBlock",
  BiuroRachunkowePageViewedStepSelectBlock = "BiuroRachunkowePageViewedStepSelectBlock",
  BiuroRachunkowePageClickedStepSelectElement = "BiuroRachunkowePageClickedStepSelectElement",
  BiuroRachunkowePageViewedPricingTableBlock = "BiuroRachunkowePageViewedPricingTableBlock",
  BiuroRachunkowePageClickedCTAButtonAtPricingTableBlock = "BiuroRachunkowePageClickedCTAButtonAtPricingTableBlock",
  BiuroRachunkowePageViewedFeaturesVerticalBlock = "BiuroRachunkowePageViewedFeaturesVerticalBlock",
  BiuroRachunkowePageClickedFeaturesVerticalElement = "BiuroRachunkowePageClickedFeaturesVerticalElement",
  BiuroRachunkowePageFormSubmitted = "BiuroRachunkowePageFormSubmitted",

  /** ZAKŁADANIE SPÓŁEK ZOO */
  ZakladanieSpolekZooPageViewedMainTitleBlock = "ZakladanieSpolekZooPageViewedMainTitleBlock",
  ZakladanieSpolekZooPageViewedStepSelectBlock = "ZakladanieSpolekZooPageViewedStepSelectBlock",
  ZakladanieSpolekZooPageClickedStepSelectElement = "ZakladanieSpolekZooPageClickedStepSelectElement",
  ZakladanieSpolekZooViewedPricingTableBlock = "ZakladanieSpolekZooViewedPricingTableBlock",
  ZakladanieSpolekZooClickedCTAButtonAtPricingTableBlock = "ZakladanieSpolekZooClickedCTAButtonAtPricingTableBlock",
  ZakladanieSpolekZooPageFormSubmitted = "ZakladanieSpolekZooPageFormSubmitted",
  ZakladanieSpolekZooViewedFaqBlock = "ZakladanieSpolekZooViewedFaqBlock",
  ZakladanieSpolekZooReadFaqQuestion = "ZakladanieSpolekZooReadFaqQuestion",

  /** FAQ */
  FaqPageViewedFaqBlock = "FaqPageViewedFaqBlock",
  FaqPageViewedFaqBlockQuestion = "FaqPageViewedFaqBlockQuestion",
  FaqPageViewedDetailsBlock = "FaqPageViewedDetailsBlock",
  FaqPageClickedCTAAtDetailsBlock = "FaqPageClickedCTAAtDetailsBlock",

  /** KONTAKT */
  KontaktPageFormSubmitted = "KontaktPageFormSubmitted",
}

export {
  GoogleAnalyticsEventCategory,
  GoogleAnalyticsEventType,
}


// WEBPACK FOOTER //
// ./src/models/google-analytics.ts